import React, {useEffect} from 'react';

const RecentlyViewedTracker = () => {

  const cookieName = 'naco_recently_viewed';

  const setCookie = (name, value, days = 7, path = '/') => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString()
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=' + path
  }

  const getCookie = (name) => {
    return document.cookie.split('; ').reduce((r, v) => {
      const parts = v.split('=')
      return parts[0] === name ? decodeURIComponent(parts[1]) : r
    }, '')
  }

  const deleteCookie = (name, path) => {
    setCookie(name, '', -1, path)
  }

  let currentCookies = getCookie(cookieName);

  if (!currentCookies) {
    currentCookies = [];
  } else {
    currentCookies = JSON.parse(currentCookies);
  }

  let currentLocation = document.querySelector('meta[name="RecentlyViewed"]') !== null ? document.querySelector('meta[name="RecentlyViewed"]').content ?? false : false;

  if (currentLocation) {
    let lastLocation = currentCookies[currentCookies.length - 1];
    if (currentLocation && lastLocation !== currentLocation) {
      currentCookies.push(currentLocation);
      currentCookies = currentCookies.slice(currentCookies.length > 21 ? currentCookies.length - 21 : 0, currentCookies.length);

      setCookie(cookieName, JSON.stringify(currentCookies));
    }
  }
}

export default RecentlyViewedTracker;
